var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.count)?_c('b-badge',{staticClass:"text-success",attrs:{"pill":"","variant":"neutral-success"}},[_c('div',{staticStyle:{"width":"16px"}},[_vm._v(" "+_vm._s(_vm.countString)+" ")])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }